export const DEAL_PEOPLE_TABLE_ID = "dealPeopleTab-table";
export const CONTRACT_PEOPLE_TABLE_ID = "contractPeopleTab-table";
